import React, { useEffect, useRef, useState } from 'react'
import './create-from-template.styles.scss';
import { useSelector } from 'react-redux';
import { getPackageFromDb, getQueryFromRtDb } from '@/utils/getDataFromDb';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import FullPageLoader from '@/components/loader/full-page-loader.component';
import TemplateGamePreview from './template-game-preview.component';


const CreateFromTemplate = ({
    managingList,
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const membership = useSelector(state => state.userData.membership);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ gamesToDisplay, setGamesToDisplay ] = useState(null);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ confirmMessage, setConfirmMessage ] = useState(null);
    const [ showUpgradeModal, setShowUpgradeModal ] = useState(false);
    const [ upgradeMessage, setUpgradeMessage ] = useState(null);
    const [ allowUpgradeClose, setAllowUpgradeClose ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    const [ allowUpgradeModal, setAllowUpgradeModal ] = useState(true);
    const approveRef = useRef();
    const gameRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        if (!userProfile) return;
        getFreeTemplateGames();
        // getMyTemplateGames();
    }, [userProfile]);

    useEffect(() => {
        console.log(managingList);
        checkMembership();
    }, [managingList]);

    function checkMembership() {
        if (!managingList || Object.values(managingList).length === 0) {
            return;
        }
        const res = testMemberRestrictions({'gameCount': Object.values(managingList).length, 'membership': membership});
        if (res.disabled && res.disabledReason.includes('games') && allowUpgradeModal) {
            const planRest = membershipRestrictions[membership.membership];
            const message = `While using the ${planRest.title}, you are only able to have ${planRest.gameCount} active Games.`;
            setAllowUpgradeClose(false);
            setShowUpgradeModal(message);
            return;
        }
    }

    async function getFreeTemplateGames() {
        getQueryFromRtDb({
            'path': 'myContent_packages/FREE',
            'query': {
                'key': 'type',
                'value': 'game'
            },
            'once': true,
            'callback': callback
        })
        function callback(data) {
            console.log(data);
            gameRef.current = {
                ...gameRef.current,
                ...data
            }
            setGamesToDisplay(gameRef.current);
        }
    }

    async function getMyTemplateGames() {
        getQueryFromRtDb({
            'path': `myContent/${userProfile.appId}`,
            'query': {
                'key': 'type',
                'value': 'game'
            },
            'once': true,
            'callback': (data) => {
                console.log(data);
                gameRef.current = {
                    ...gameRef.current,
                    ...data
                }
                setGamesToDisplay(gameRef.current);
            }
        })
    }

    function createGame(gameId) {
        if (!gameId) return;
        const gameElement = gameRef.current[gameId];
        if (!gameElement) {
            setAlertMessage('This template game is not available at the moment. Please try again later.');
            return;
        }
        if (membership?.membership === 0 && gameElement.data.gameType === 'full') {
            setUpgradeMessage('Because this is a game template that requires full access to all game features, you must upgrade before using it.');
            setAllowUpgradeClose(true);
            setShowUpgradeModal(true);
            return;
        }
        console.log(managingList)
        if (Object.values(managingList).length >= membershipRestrictions[membership?.membership].gameCount) {
            setUpgradeMessage(`You have reached the maximum number of games allowed with your current plan. Please upgrade to create more games, or archive existing games to free up space.`);
            setAllowUpgradeClose(true);
            setShowUpgradeModal(true);
            return;
        }
        setConfirmMessage(`Are you sure you want to create a new game using the template called <b>"${gameElement.data.name}"</b>? This will create a new game in your account.`);
        approveRef.current = () => {
            approveRef.current = null;
            continueCreateGame();
        }

        async function continueCreateGame() {
            setAllowUpgradeModal(false);
            setLoading(true);
            const newGame = await UseCloudFunction(
                'duplicateOwnerGame',
                {
                    'gameId': gameElement.data.gameId,
                    'appId': userProfile.appId,
                    'userProfile': userProfile,
                    'fromTemplate': true
                }
            )
            setLoading(false);
            console.log(newGame);
            if (newGame.error) {
                setAlertMessage(`Something went wrong while creating the game. Please try again later. (Error: ${newGame.error})`);
                return;
            }
            setAlertMessage(`Your new game has been created successfully! You can now start editing it.`);
            approveRef.current = () => {
                navigate(`/manage/${newGame.gameData.path}`);
            }
        }
    }

    return (
        <div className={`create-from-template ${screenSize}`}>
            <div className='create-from-template-content g-card'>
                <BackButton cancel={() => navigate(-1)} />
                <div className="g-space-1"></div>
                <div className='card-title'>
                    <span>Start With a Template</span>
                </div>
                <hr />
                <Routes>
                    <Route path='' element={
                        <div className='create-from-template-content__sub'>
                            <p>Choose a template below to start creating your game.</p>
                            {/* Template list will go here */}
                            <div className='template-list'>
                                {
                                    (gamesToDisplay && Object.keys(gamesToDisplay).length > 0)
                                    ? Object.keys(gamesToDisplay).map((elementId, index) => {
                                        const game = gamesToDisplay[elementId];
                                        if (membership?.membership < game.data.membershipRequired) return;
                                        let gameType = 'Full Game'
                                        if (game.data.gameType === 'currency') {
                                            gameType = 'Currency and a Store Only';
                                        } else if (game.data.gameType === 'points') {
                                            gameType = 'Points and Leaderboards Only';
                                        }
                                        return (
                                            <div key={index} className='template-item g-list-item'>
                                                <div className="item-grid">
                                                    <div>
                                                        <ImageContainer src={game.data.url} alt={game.gameName} />
                                                    </div>
                                                    <div className='template-info'>
                                                        <h2>{game.data.name}</h2>
                                                        <div className='meta'><b>Game Type:</b> {gameType}</div>
                                                        <div className="g-space-0-5"></div>
                                                        <div className='meta'>
                                                            {
                                                                (screenSize === 'mobile') 
                                                                ?
                                                                <Link to={game.data.path}>
                                                                    Learn More
                                                                </Link>
                                                                :
                                                                <Link to={game.data.path}>
                                                                <button className='g-button small-btn'>
                                                                    Learn More
                                                                </button>
                                                                </Link>
                                                            }   
                                                        </div>
                                                        {/* <div className='meta'><b>Description:</b></div>
                                                        <div dangerouslySetInnerHTML={{__html: game.data.desc}}></div> */}
                                                    </div>
                                                </div>
                                                <div className="g-space-0-5"></div>
                                                <div className='buttons'>
                                                    <button 
                                                        className={`g-button med-btn`}
                                                        onClick={() => createGame(elementId)}>
                                                        Use This Template
                                                    </button>
                                                </div>
                                            </div>
                                        )
                                    })
                                    : <p>No templates available.</p>
                                }
                            </div>
                        </div>
                    }></Route>
                    <Route path=':templatePath' element={
                        <TemplateGamePreview />
                    }></Route>
                </Routes>
            </div>
            {
                (screenSize === 'mobile') &&
                <div className='g-space-1'></div>
            }
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage}
                onApprove={approveRef.current} />
            <ModalConfirm
                show={confirmMessage}
                cancel={() => setConfirmMessage(null)}
                message={confirmMessage}
                onApprove={approveRef.current} />
            <UpgradeRequiredModal
                show={showUpgradeModal}
                cancel={() => setShowUpgradeModal(false)}
                message={upgradeMessage}
                closeButton={allowUpgradeClose}
                newTab={false} />
            <FullPageLoader
                show={loading} />
        </div>
    )
}

export default CreateFromTemplate